import { useEffect, useRef, useState } from "react";
import i18n from "../../i18n";
import { useGetLanguagesQuery } from "../../services/api/language.api";
import style from "./LanguageSelection.module.css";
import Tooltip from "../tooltip/tooltip";
import { tWithKeyAttr as t } from "../../i18nHelper";
export const LanguageSelection = () => {
  
  const { data: languages = [], isLoading,error:myError } = useGetLanguagesQuery();
  const [open, setOpen] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

  const [selectedLang, setSelectedLang] = useState<string | null>(null);

  const wrapperRef = useRef<HTMLDivElement>(null);

  const changeLanguage = (lang: string) => {
    console.log(lang);
    
    setSelectedLang(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem("i18nextLng", lang);
    setTimeout(() => {
      window.location.reload();
    }, 200);
  };

  const current =
    languages.find(
      (l) => l.code === selectedLang || l.code === localStorage.getItem("i18nextLng")
    ) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={style.languageContainer} ref={wrapperRef}>
      {current ? (
        <div className={style.languageIcon} onClick={() => setOpen(!open)}>
          <div onMouseEnter={()=>setShowTooltip(true)} onMouseLeave={()=>setShowTooltip(false)} className={style.tooltipWrapper}>
            <Tooltip isShown={showTooltip}  position="bottom">
              {t("SELECT_YOUR_LANGUAGE")}
            </Tooltip>
            <img
              src={`https://flagcdn.com/${current.countryCode.toLowerCase()}.svg`}
              className={style.img}
              alt={current.name}
            />
          </div>

          {open && (
            <ul className={style.languagePopup}>
              <button
                className={style.closeButton}
                onClick={() => setOpen(false)}
              >
                ✕
              </button>

              {languages
                .filter((x) => x.code !== current.code)
                .map((x, i) => (
                  <li
                    key={i}
                    onClick={() => {
                      changeLanguage(x.code);
                      setOpen(false);
                    }}
                    className={style.languageItem}
                  >
                    <img
                      src={`https://flagcdn.com/${x.countryCode.toLowerCase()}.svg`}
                      className={style.img}
                      alt={x.name}
                    />
                    <span>{x.name}</span>
                  </li>
                ))}
            </ul>
          )}
        </div>
      ) : (
        <span>{t("CHOOSE_LANGUAGE")}</span>
      )}
    </div>
  );
};
